import React from 'react';
import './TopperStrategies.css';
import { FileText, ExternalLink } from 'lucide-react';

const strategies = [
  {
    name: 'Aditya Raj',
    description: 'AIR 1 Strategy to crack the UPSC CSE in first attempt.',
    year: 2024,
    link: 'https://example.com/aditya-strategy.pdf',
    type: 'PDF',
  },
  {
    name: 'Sneha Kapoor',
    description: 'Detailed blog post on time management and note making.',
    year: 2023,
    link: 'https://example.com/sneha-strategy-blog',
    type: 'Blog',
  },
  {
    name: 'Kunal Mehra',
    description: 'Smart preparation plan for Prelims + Mains + Interview.',
    year: 2022,
    link: 'https://example.com/kunal-plan.pdf',
    type: 'PDF',
  },
  {
    name: 'Riya Nair',
    description: 'Blog insights on daily revision and mock test practice.',
    year: 2024,
    link: 'https://example.com/riya-daily-routine',
    type: 'Blog',
  },
];

const TopperStrategies = () => {
  return (
    <section className="topper-strategy-section">
      <div className="topper-strategy-container">
        <div className="topper-strategy-header">
          <FileText className="topper-strategy-icon" />
          <h2 className="topper-strategy-title">Topper Strategies</h2>
          <p className="topper-strategy-subtitle">
            Explore the preparation secrets and success paths of our toppers.
          </p>
        </div>

        <div className="topper-strategy-grid">
          {strategies.map((item, index) => (
            <div className="topper-strategy-card" key={index}>
              <div className="topper-strategy-card-header">
                <span className="topper-strategy-year">{item.year}</span>
                <span className="topper-strategy-type">{item.type}</span>
              </div>
              <h3 className="topper-strategy-name">{item.name}</h3>
              <p className="topper-strategy-description">{item.description}</p>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="topper-strategy-link"
              >
                Read Strategy <ExternalLink className="topper-strategy-link-icon" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopperStrategies;
